import React from "react";
import { Layout, Layouts, Responsive, WidthProvider } from "react-grid-layout";

/* Config */
import config from "../../app/config.json";

/* Components */

/* APIs - Hooks - Utils */
import { useAppSelector } from "../../app/hooks";
import { InfoCard, PullRequestCard, StatusCard } from "./Metadata.elements";
import { mockAppInfo, mockPullRequests, mockStatuses } from "./fixtures";
import { Banner } from "../../utils/components/Common";

const ResponsiveGridLayout = WidthProvider(Responsive);

const Metadata = (): JSX.Element => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const user = useAppSelector((state) => state.user.user);

  /* Mock Data */
  const mockStatus = mockStatuses[0]; // Use the first mock status for demo
  const mockDependabotPullRequests = mockPullRequests.slice(5, 20); // Use pull requests from index 5 to 20 for dependabot
  const mockDevPullRequests = mockPullRequests.slice(0, 5); // Use the first 5 mock pull requests for demo

  const getSavedLayout = () => {
    const savedLayout = localStorage.getItem(
      config.constants.layout.metadata.storageName
    );
    if (savedLayout) {
      return JSON.parse(savedLayout);
    }
    return {
      lg: config.constants.layout.metadata.large,
      md: config.constants.layout.metadata.medium,
      sm: config.constants.layout.metadata.small,
    };
  };

  const onLayoutChange = (_newLayout: Layout[], allLayouts: Layouts) => {
    localStorage.setItem(
      config.constants.layout.metadata.storageName,
      JSON.stringify(allLayouts)
    );
  };

  return (
    <>
      {isLoggedIn && user ? (
        <ResponsiveGridLayout
          className="layout"
          layouts={getSavedLayout()}
          cols={{ lg: 12, md: 12, sm: 12 }}
          rowHeight={
            window.innerWidth >= 1200
              ? 60 // lg
              : window.innerWidth >= 996
                ? 50 // md
                : 40 // sm
          }
          width={window.innerWidth}
          isResizable={true}
          isDraggable={false}
          breakpoints={{ lg: 1200, md: 996, sm: 768 }}
          onLayoutChange={onLayoutChange}
        >
          <div key="metadata-status">
            <StatusCard status={mockStatus} />
          </div>
          <div key="metadata-info">
            <InfoCard appInfo={mockAppInfo} />
          </div>
          <div key="metadata-pr-dependabot">
            <PullRequestCard
              isDependabot
              pullRequests={mockDependabotPullRequests}
            />
          </div>
          <div key="metadata-pr-dev">
            <PullRequestCard pullRequests={mockDevPullRequests} />
          </div>
        </ResponsiveGridLayout>
      ) : (
        <Banner
          alert
          heading="You are not authenticated"
          message="Please log in to view metadata information."
        />
      )}
    </>
  );
};

export default Metadata;
